import KyeAddressLabel from './label'
export default {
  name: 'KyeAddressAreaWrap',
  components: { KyeAddressLabel },
  props: {
    labelData: Object,
    areaProps: Object,
    validateData: {
      type: Object,
      default: () => ({})
    },
  },
  render(h) {
    const { $props } = this
    const { labelData, areaProps, validateData } = $props
    const areaLabel = labelData && labelData.areaLabel
    const labelWidth = labelData && labelData.labelWidth
    const areaBind = {
      props: areaProps,
      class: 'kye-area',
      ref: 'kyeAreaWrap',
      on: {
        confirm: this.areaConfirm,
        'area-item-click': this.areaItemClick,
        'panel-change': this.areaPanelChange,
        clear: this.areaClear
      }
    }
    const renderArea = () => {
      return <kye-area { ...areaBind }></kye-area>
    }
    const renderLabel = () => {
      return <kye-address-label require={validateData.addressRequire} value={ areaLabel } labelWidth={labelWidth}></kye-address-label>
    }
    const contentArea = renderArea()
    const contentLabel = renderLabel()
    return <div class="kye-area-wrap">
        {contentLabel}
        {contentArea}
    </div>
  },
  created () {
    this.currentAreaId = null
  },
  methods: {
    clearCurrentAreaId () {
      this.currentAreaId = null
    },
    areaClear() {
      this.$emit('areaClear')
    },
    areaConfirm(data) {
      if (!data) {
        this.$emit('confirm', null)
        return
      }
      if (this.currentAreaId === data.areaId) {
        this.$emit('confirm', data, true)
        return
      }
      this.currentAreaId = data.areaId
      this.$emit('confirm', data)
    },
    areaItemClick(data) {
      this.$emit('areaItemClick', data)
    },
    areaPanelChange(data) {
      this.$emit('areaPanelChange', data)
    },
    validate(data, custom) {
      if (custom) {
        return this.$refs.kyeAreaWrap.validate(custom.validate, custom.validateMessage)
      } else {
        return this.$refs.kyeAreaWrap.validate(data, this.validateData.areaError)
      }
    },
    clearValidate() {
      this.$refs.kyeAreaWrap.clearValidate()
    }
  }
}




// WEBPACK FOOTER //
// ./src/public/components/kye-address/components/area-wrap.js